import React from 'react';
import ReactDOM from 'react-dom/client';
import "amfe-flexible";
import "intersection-observer"
import App from '@/App';
import '@/styles'
import { HashRouter, BrowserRouter } from 'react-router-dom'
import ArticlesApp from '@/ArticlesApp'
import CloudstoreApiApp from '@/pages/cloudstore-api'

// 按当前 pathname 分流（共用同一个 bundle，各自有独立 index.html）：
//   /articles*        → 文章站（BrowserRouter，真实路径 域名/articles/xxx）
//   /cloudstore-api*  → API 控制台（HashRouter，域名/cloudstore-api/#/dashboard）
//   其余（/）         → 主站（HashRouter，域名/#/xxx）
const pathname = window.location.pathname;
const isArticles = pathname.startsWith('/articles');
const isCloudstoreApi = pathname.startsWith('/cloudstore-api');

const container = document.getElementById('root') as HTMLElement;

if (isArticles) {
  const tree = (
    <React.StrictMode>
      <BrowserRouter>
        <ArticlesApp />
      </BrowserRouter>
    </React.StrictMode>
  );
  // 文章页在构建时会被预渲染成静态 HTML（见 scripts/prerender-articles.js）。
  // 生产环境下 #root 已有内容 → hydrate 接管；预渲染阶段（空壳）或其它情况 → 正常渲染。
  if (container.hasChildNodes()) {
    ReactDOM.hydrateRoot(container, tree);
  } else {
    ReactDOM.createRoot(container).render(tree);
  }
} else {
  // 主站与 cloudstore-api 共用一个 HashRouter，按 pathname 决定挂载哪个 app。
  // 路由形如 域名/cloudstore-api/#/dashboard、域名/#/xxx。
  const tree = (
    <React.StrictMode>
      <HashRouter>
        {isCloudstoreApi ? <CloudstoreApiApp /> : <App />}
      </HashRouter>
    </React.StrictMode>
  );

  // cloudstore-api 的 Pricing（默认页）会被预渲染成静态 HTML 并注入初始数据
  // （见 scripts/prerender-pricing.js）。仅当【是 cloudstore-api】【当前 hash 指向
  // Pricing 路由】【#root 已有预渲染内容】三者同时满足时才 hydrate——因为所有 hash
  // 路由共用同一份 index.html，若在 #/dashboard 等其它路由上 hydrate 会与预渲染的
  // Pricing 结构 mismatch。其余情况一律 createRoot（会清空并重渲染，安全）。
  const hash = window.location.hash.replace(/^#/, "");
  const isPricingRoute = hash === "" || hash === "/" || hash === "/pricing";
  if (isCloudstoreApi && isPricingRoute && container.hasChildNodes()) {
    ReactDOM.hydrateRoot(container, tree);
  } else {
    ReactDOM.createRoot(container).render(tree);
  }
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
